import ClockTB from "../../../components/Common/ClockTB/ClockTB";
import { useEffect, useState, createContext, useContext } from "react";
import RoundedButtonTB from "../../../components/Common/RoundedButtonTB/RoundedButtonTB";
import AudioChangeRate from "../../../components/Common/AudioChangeRate/AudioChangeRate";
import { useLocation, useNavigate } from 'react-router-dom'
import Button from "../../../components/Common/Button";
import mainContext from "../../../context/mainContext";
import styles from "./style.module.css";
import { PlayerProvider } from "../../../context/playerContext";


const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
const gainNode = audioCtx.createGain();
export const clockContex = createContext();

export default function PushUpTimer2() {
  const navigate = useNavigate()
  const location = useLocation();
  const [showStopBtn, setShowStopBtn] = useState(false);
  const [showContinueBtn, setShowContinueBtn] = useState(false);
  const navigateObject = location.state.navigateObject;
  const [dataNewLpm, setDataNewLpm] = useState(navigateObject.lpm);
  const [play, setPlay] = useState(false);
  const [isFinish, setIsFinish] = useState(false);
  const { TR_duration, header } = useContext(mainContext);
  const timeInSeconds = TR_duration;//time for playing the track 180 is 3Min
  const [counterPauses, setCounterPauses] = useState(0)

  const continueBtnClick = () => navigate("/train-reading/questions", { state: { navigateObject } });

  const stopBtnClick = () => {
    setPlay(false)
    console.log({ dataNewLpm });
    navigateObject.rateData.LPM = dataNewLpm
    navigate("/train-reading/questions", { state: { navigateObject } });
  };

  useEffect(() => {
    navigateObject.roundCounter === 4
      ? setShowStopBtn(true)
      : setShowStopBtn(false);
    header.setPageName(navigateObject.roundCounter === 4 ? `PUSHUP Round ${navigateObject.roundCounter}/4, up to 3-min` : `PUSHUP Round ${navigateObject.roundCounter}/4, 3-min`);
    return () => header.setPageName(``);
  }, [])


  return (
    <>
      {navigateObject.roundCounter === 4 && <div className={styles.instruction4} >Press STOP button when Rate FIRST FEELS FAST</div>}
      <div className={navigateObject.roundCounter === 4 ? "pages_small" : "pages"} style={window.buildType === "iPhone" ? { position: "relative", minHeight: "70vh" } : { position: "relative" }}>
        {/* <PlayerProvider {...{ audioCtx, gainNode }}> */}
        <clockContex.Provider value={{ play, setPlay, isFinish, setIsFinish, counterPauses, setCounterPauses }}>
          <ClockTB freeStyle={false} time={timeInSeconds} navigateObject={navigateObject} setShowContinueBtn={setShowContinueBtn} />
          {!isFinish && <RoundedButtonTB play={play} setPlay={setPlay} setCounterPauses={setCounterPauses} />}
          <AudioChangeRate setDataNewLpm={setDataNewLpm} />
        </clockContex.Provider>
        {/* </PlayerProvider> */}
      </div>
      <div style={window.buildType === "iPhone" ? { position: "fixed", bottom: "1rem", width: "100%" } : { marginTop: "auto" }}>        {/* //TODO:majorCSSChange*/}
        {(showContinueBtn && !showStopBtn) && (
          <Button startFunction={continueBtnClick} title={"CONTINUE"} fontColor="white" />
        )}
        {showStopBtn && (
          <Button startFunction={stopBtnClick} title={showStopBtn && !showContinueBtn ? "STOP" : "CONTINUE"} fontColor="white" />
        )}
      </div></>
  );
}










//----------**************************************

// import { React, useState, useEffect, useRef, useContext } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { pageNameContext } from "../../../components/layout/Layout";
// import Clock from "../../../components/common/Clock";
// import SubmitBtn from "../../../components/common/SubmitBtn";
// import styles from "./style.module.css";

// // const audio = require("../../../assets/audio/woc.mp3");

// export default function PushUpTimer(props) {
//   let audioRef = useRef();
//   const [showStopBtn, setShowStopBtn] = useState(false);
//   const [showContinueBtn, setShowContinueBtn] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { pageName, setPageName } = useContext(pageNameContext);

//   const navigateObject = location.state.navigateObject;
//   setPageName(`Pushup ${navigateObject.roundCounter}/4`);

//   useEffect(() => {
//     // audioRef.current.src = audio;
//     // remove
//     navigateObject.roundCounter === 4
//       ? setShowStopBtn(true)
//       : setShowStopBtn(false);
//     // remove when clock onplay work
//   }, []);

//   // remove
//   function navigateInst() {
//     showContinue();
//   }

//   // function for Clock.onComplete event
//   const showContinue = () => {
//     setShowContinueBtn(true);
//     navigateObject.roundCounter++;
//   };

//   const changeRate = () => {};

//   const clockFunctions = {
//     onStart: playAudio,
//     onPause: pauseAudio,
//     onComplete: showContinue,
//     onTick: changeRate,
//   };

//   // const continueBtnClick = () => {
//   //   navigate("/train-reading/questions");
//   // };

//   return (
//     <div>
//       <div>
//         <Clock freeStyle={false} func={clockFunctions} />
//         {/* <audio ref={audioRef}> </audio> */}
//         {showContinueBtn && (
//           <SubmitBtn
//             type="link"
//             path="/train-reading/questions"
//             name="continue"
//           />
//         )}
//         {showStopBtn && (
//           <SubmitBtn type="link" path="/train-reading/questions" name="stop" />
//         )}
//       </div>
//       {/* remove */}
//       <button onClick={navigateInst}> show continue </button>
//     </div>
//   );
// }

// ----------- ayellet && shacher fix 28/6 19:40

// import React from 'react'
// import { useState, useEffect } from 'react';

// export default function PushUpTimer(props) {

//     const [minutes, setMinutes] = useState(3);
//     const [seconds, setSeconds] = useState(0);
//     useEffect(() => {
//         let myInterval = setInterval(() => {
//             if (seconds > 0) {
//                 setSeconds(seconds - 1);
//             }
//             if (seconds === 0) {
//                 if (minutes === 0) {
//                     clearInterval(myInterval)
//                 } else {
//                     setMinutes(minutes - 1);
//                     setSeconds(59);
//                 }
//             }
//         }, 1000)
//         return () => {
//             clearInterval(myInterval);
//         };
//     });

//     return (
//         <div>
//             {minutes === 0 && seconds === 0
//                 ? null
//                 : <h1> {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
//             }
//         </div>
//     )
// }

// function Music() {

// }

//----------******************************************************








// import { React, useState, useEffect, useRef, useContext } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { pageNameContext } from "../../../components/layout/Layout";
// import Clock from "../../../components/common/Clock";
// import SubmitBtn from "../../../components/common/SubmitBtn";
// import styles from "./style.module.css";

// // const audio = require("../../../assets/audio/woc.mp3");

// export default function PushUpTimer(props) {
//   let audioRef = useRef();
//   let continueRef = useRef();
//   let stopRef = useRef();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [pageName, setPageName] = useContext(pageNameContext);

//   const navigateObject = location.state.navigateObject;

//   setPageName(`Pushup ${navigateObject.roundCounter}/4`);

//   useEffect(() => {
//     // audioRef.current.src = audio;
//     // remove
//     let x = "";
//     navigateObject.roundCounter === 4
//       ? (stopRef.current.className = styles.btnshow)
//       : (x = "");
//   }, []);

//   // remove
//   function navigateInst() {
//     // continueRef.current.className = styles.btnshow;
//     navigateObject.roundCounter++;
//     navigate("/train-reading/instructions", { state: { navigateObject } });
//   }

//   const playAudio = () => {
//     // audioRef.current.play();
//     // let x = "";
//     // navigateObject.roundCounter === 4
//     //   ? (stopRef.current.className = styles.btnshow)
//     //   : (x = "");
//   };

//   const pauseAudio = () => {
//     // audioRef.current.pause();
//   };

//   const showContinue = () => {
//     continueRef.current.className = styles.btnshow;
//   };

//   const changeRate = () => {};

//   const clockFunctions = {
//     onStart: playAudio,
//     onPause: pauseAudio,
//     onComplete: showContinue,
//     onTick: changeRate,
//   };

//   // const continueBtnClick = () => {
//   //   navigate("/train-reading/Questions");
//   // };

//   return (
//     <div>
//       <div>
//         <Clock freeStyle={false} func={clockFunctions} />
//         {/* <audio ref={audioRef}> </audio> */}
//         <div className={styles.btnhide} ref={continueRef}>
//           <SubmitBtn path="/train-reading/Questions" name="continue" />
//         </div>
//         <div className={styles.btnhide} ref={stopRef}>
//           <SubmitBtn path="/train-reading/Questions" name="stop" />
//         </div>
//       </div>
//       {/* remove */}
//       <button onClick={navigateInst}> navigate to inst</button>
//     </div>
//   );
// }

// ----------- ayellet && shacher fix 28/6 19:40

// import React from 'react'
// import { useState, useEffect } from 'react';



// export default function PushUpTimer(props) {

//     const [minutes, setMinutes] = useState(3);
//     const [seconds, setSeconds] = useState(0);
//     useEffect(() => {
//         let myInterval = setInterval(() => {
//             if (seconds > 0) {
//                 setSeconds(seconds - 1);
//             }
//             if (seconds === 0) {
//                 if (minutes === 0) {
//                     clearInterval(myInterval)
//                 } else {
//                     setMinutes(minutes - 1);
//                     setSeconds(59);
//                 }
//             }
//         }, 1000)
//         return () => {
//             clearInterval(myInterval);
//         };
//     });

//     return (
//         <div>
//             {minutes === 0 && seconds === 0
//                 ? null
//                 : <h1> {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
//             }
//         </div>
//     )
// }

// function Music() {


// }


